/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SaveDiaryProfileCommand { 
    azureAdUpn?: string | null;
    consentGiven?: boolean;
    gender?: number;
    birthYear?: number;
    heightCm?: number;
    weightKg?: number;
    activityLevel?: number;
}

